import { IonCol, IonContent, IonImg, IonPage, IonRow } from '@ionic/react';
import { Link } from 'react-router-dom';
import { translation } from '../models/translation';

const NotFoundPage: React.FC = () => {

  const siteText = translation();
  const lan = siteText.lan.replace("/","")
  return (
    <IonPage className='pageContent'>
      <IonContent fullscreen className='ion-text-center'>
        <IonRow className='sw_sp_lg'>
          <IonCol offsetSm='2' sizeSm='8'>
            < IonImg className='home_logo sw_mb_sm' src={`${process.env.PUBLIC_URL}/assets/swissdonations_logo_01.png`}></IonImg>
            <h1 className='h2'>{siteText.notFoundTitle}</h1>
            <p>{siteText.notFoundText}</p>
            <Link to={`/${lan}/`}>{siteText.notFoundPrimary}</Link>
          </IonCol>
        </IonRow>
      </IonContent>
    </IonPage>
  );
};

export default NotFoundPage;
